import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getOrderDetails, goPayGate} from '../actions/orderActions'
import { goPayPasargadGate } from '../actions/orderActions'
import { Row, Col, Button, ListGroup, Card ,Form } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { BASE_URL } from '../constants/urlConstants'
import PersianText from '../components/PersianText'



function OrderScreen() {

    const { kit, id } = useParams()

    const orderId = id

    const dispatch = useDispatch()
    const orderDetails = useSelector(state => state.orderDetails)
    const { order, error, loading } = orderDetails



    useEffect(() => {
        dispatch(getOrderDetails(kit, orderId))
    }, [dispatch])

    // handle pay order
    const [payGateMessage, setPayGateMessage] = useState('')

    const [selectedOption, setSelectedOption] = useState(""); // ذخیره گزینه انتخاب‌شده

    const [selectedCode, setselectedCode] = useState("")
    const [selectedAddress, setselectedAddress] = useState("")

    const handleOptionChange = (e) => {
        setSelectedOption(e.target.value);
    };

    const payOrderHandler = (e) => {
        e.preventDefault()//صفحه ریلود نمیشود
        if (!selectedAddress){
            alert("لطفا آدرس را وارد کنید");
        } else if (!selectedCode){
            alert("لطفا کد پستی  را وارد کنید");
        }else{
            // goPayGate(orderId, order.kit.gov_price,selectedAddress,selectedCode)
            //     .then(function (response) {
            //         window.location.assign(`https://www.zarinpal.com/pg/StartPay/` + response.data.data.authority)
            //     }).catch(function (error) {
            //         if (error.response.data && error.response.data.detail) {
            //             setPayGateMessage(error.response.data.detail)
            //         } else {
            //             setPayGateMessage(error.response.data)
            //         }
            //     })
            //  }



//new
            goPayPasargadGate(orderId, order.kit.gov_price,selectedAddress,selectedCode)
                .then(function (response) {
                    window.location.assign(response.data)
                }).catch(function (error) {
                    if (error.response.data && error.response.data.detail) {
                        setPayGateMessage(error.response.data.detail)
                    } else {
                        setPayGateMessage(error.response.data)
                    }
                })
             }






        // if (!selectedOption) {
        //     alert("لطفا روش پرداخت را انتخاب کنید");
        // }
        //  else if (!selectedAddress){
        //     alert("لطفا آدرس را وارد کنید");
        // } else if (!selectedCode){
        //     alert("لطفا کد پستی  را وارد کنید");
        // }else{
        //  if (selectedOption == "1") {
        //     //alert("سیستم در حال بروزرسانی می باشد...!");
        //     goPayGate(orderId, order.kit.gov_price,selectedAddress,selectedCode)
        //         .then(function (response) {
        //             window.location.assign(`https://www.zarinpal.com/pg/StartPay/` + response.data.data.authority)
        //         }).catch(function (error) {
        //             if (error.response.data && error.response.data.detail) {
        //                 setPayGateMessage(error.response.data.detail)
        //             } else {
        //                 setPayGateMessage(error.response.data)
        //             }
        //         })
        // } else if (selectedOption == "2") {
        //     console.log("salam")
        //     // goPayPasargadGate(orderId, order.kit.gov_price)
        //     //     .then(function (response) {
        //     //         window.location.assign(response.data)
        //     //     }).catch(function (error) {
        //     //         if (error.response.data && error.response.data.detail) {
        //     //             setPayGateMessage(error.response.data.detail)
        //     //         } else {
        //     //             setPayGateMessage(error.response.data)
        //     //         }
        //     //     })
        // }}
        setSelectedOption('')
        setselectedAddress('')
        setselectedCode('')

    }


    return loading ? (
        <Loader />
    ) : error ? (
        <Message variant='danger' text={error} />
    ) :
        (<div>
            <h1><PersianText>سفارش شماره : {order.data.trackNumber}</PersianText></h1>
            <hr />

            <Row>
                <Col md={6}>
                    <ListGroup variant='flush'>
                        <ListGroup.Item>
                            <h2>مشخصات</h2>
                            <p><strong>نام و نام خانوادگی : </strong>{order.data.fullName}</p>
                            <p> <strong>تلفن تماس : </strong></p>
                            <p> <PersianText>  {order.data.mobile} </PersianText></p>

                        </ListGroup.Item>
                        <ListGroup.Item>

                            <p>
                                <strong>منطقه : </strong>
                                {order.data.zoneTitle}
                            </p>
                            
                           
                            <div>
                                <label className='p-1 disc text-wrap d-block'>
                                    * در وارد کردن آدرس و کد پستی دقت کنید بسته بندی لوازم از طریق پست رایگان ارسال می شود ، درصورت اشتباه بودن آدرس یا کدپستی هزینه تحویل از درب انبار نجف آباد و هزینه ارسال اشتباه پست به عهده مشترک خواهد بود. 
                                </label>
                                <textarea
                                    class= "form-control border border-secondary" aria-label="With textarea"
                                    type="text"
                                    name="option"
                                    value={selectedAddress}
                                    onChange={(e) => setselectedAddress(e.target.value)}
                                    //rows="5" // تعداد ردیف‌ها
                                    //cols="40" // تعداد ستون‌ها
                                    placeholder="آدرس ..."
                                />

                            </div>
                            <div>
                                              <Form.Group controlId='trackcode'>
                                                <Form.Label></Form.Label>
                                                <Form.Control
                                                  type='text'
                                                  name="option"
                                                  placeholder='کد پستی'
                                                  value={selectedCode}
                                                  onChange={(e) => setselectedCode(e.target.value)}
                                                ></Form.Control>
                                              </Form.Group>
                                            </div>
                        </ListGroup.Item>
                        <ListGroup.Item>

                            <p>
                                <strong>مشخصات کالا : </strong>
                                <PersianText>  {order.kit.description}</PersianText>
                            </p>

                        </ListGroup.Item>

                    </ListGroup>
                </Col>
                <Col md={6}>
                    <Card className='p-3 my-3 rounded '>
                        <Card.Img src={`${BASE_URL}/${order.kit.image}`} className='card-img-cus' />
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col >
                    <Card>
                        <ListGroup variant='flush'>
                            <ListGroup.Item>
                                <h2>انجام سفارش</h2>
                            </ListGroup.Item>
                            {/* <ListGroup.Item>
                                <Row>
                                    <Col>قطر کنتور : </Col>
                                    <Col>{order.data.packId} </Col>
                                </Row>
                            </ListGroup.Item> */}
                            <ListGroup.Item
                                className={order.paySuccess ? 'd-none' : ''}>
                                <Row>
                                    <Col>مبلغ : </Col>
                                    <Col> {order.kit.price.toLocaleString("fa-IR")} ریال</Col>
                                </Row>
                            </ListGroup.Item>

                            <ListGroup.Item
                                className={order.paySuccess ? 'd-none' : ''}>
                                <Row>
                                    <Col> مبلغ با ارزش افزوده :</Col>
                                    <Col> {order.kit.gov_price.toLocaleString("fa-IR")} ریال</Col>
                                </Row>
                            </ListGroup.Item>
                            <ListGroup.Item
                                className={order.paySuccess ? '' : 'd-none'}
                            >
                                {<Message variant='danger' text='این سفارش پرداخت شده است' />}
                            </ListGroup.Item>
                            <form onSubmit={payOrderHandler}>
                                {/* <ListGroup.Item
                                    className={order.paySuccess ? 'd-none' : ''}>

                                    <Row>
                                        <Col><p>روش پرداخت</p></Col>
                                        <Col>
                                            <div>
                                                <input
                                                    type="radio"
                                                    name="option"
                                                    value="1"
                                                    checked={selectedOption === "1"}
                                                    onChange={handleOptionChange}
                                                /><label className='p-1'>
                                                    <img
                                                        src={`${BASE_URL}/public/images/logo/zplogo.png`}
                                                        alt="زرین پال"
                                                        style={{
                                                            maxWidth: "90%", // تصویر حداکثر به اندازه والدش باشد
                                                            height: "auto",  // ارتفاع متناسب با عرض تنظیم شود
                                                        }}
                                                    />
                                                </label>

                                            </div>
                                        </Col>
                                        <Col>
                                            <div>
                                                <input
                                                    type="radio"
                                                    name="option"
                                                    value="2"
                                                    checked={selectedOption === "2"}
                                                    onChange={handleOptionChange}
                                                /><label className='p-1'>
                                                    <img
                                                        src={`${BASE_URL}/public/images/logo/pasargad.png`}
                                                        alt="بانک پاسارگاد"
                                                        style={{
                                                            maxWidth: "90%", // تصویر حداکثر به اندازه والدش باشد
                                                            height: "auto",  // ارتفاع متناسب با عرض تنظیم شود
                                                        }}
                                                    />
                                                </label>

                                            </div>
                                        </Col>
                                    </Row>
                                </ListGroup.Item> */}
                                <ListGroup.Item
                                    className={payGateMessage ? '' : 'd-none'}
                                >
                                    <Message variant='danger' text={payGateMessage} />
                                </ListGroup.Item>

                                <ListGroup.Item
                                    className={order.paySuccess ? 'd-none' : ''}>
                                     <Button
                                        type='text'

                                    >پرداخت</Button> 
                                    {/* <p><strong>مبلغ به این شماره شبا واریز نمایید. </strong></p>
                                    <p><strong>اطلاعات آدرس و کدپستی و تصویر واریزی و کدسفارش 8 رقی را در پیام رسان ایتا به شماره 09157575576 ارسال فرمایید </strong></p>
                                    <p><strong>IR560590024800403503267001</strong></p>
                                    <p><strong>6393468800106966</strong></p>
                                    <p><strong>به نام شرکت نگین بسپار شرق</strong></p> */}

                                </ListGroup.Item>
                            </form>
                        </ListGroup>
                    </Card>
                </Col>
            </Row>
        </div>

        )
}

export default OrderScreen
